import React from "react";
import "./ErrorBoundry.css"

const RouteErrorBoundary = () => (
  <div className="error-boundary">
    <h1>Something went wrong!</h1>
    <p>We're sorry, but an unexpected error occurred.</p>
    <button className="cancelButton" onClick={() => window.location.reload()}>Reload</button>
  </div>
);

export default RouteErrorBoundary;